import gql from 'graphql-tag';
import { DISCUSSION_MESSAGE_FRAGMENT } from './fragment';

export const SEND_MESSAGE_TO_DISCUSSION = gql`
  mutation SendMessageToDiscussion($input: SendMessageToDiscussionInput!) {
    sendMessageToDiscussion(input: $input) {
      ...DiscussionMessageFragment
    }
  }
  ${DISCUSSION_MESSAGE_FRAGMENT}
`;

export const DELETE_MESSAGE_IN_DISCUSSION = gql`
  mutation DeleteMessageInDiscussion($id: Int!) {
    deleteMessageInDiscussion(id: $id) {
      ...DiscussionMessageFragment
    }
  }
  ${DISCUSSION_MESSAGE_FRAGMENT}
`;

export const SET_DISCUSSION_MESSAGES_SEEN = gql`
  mutation SetDiscussionMessagesSeen($input: DiscussionMessagesSeenInput!) {
    setDiscussionMessagesSeen(input: $input)
  }
`;

export const CREATE_FEEDBACK = gql`
  mutation CreateFeedback($input: CreateFeedbackInput!) {
    createFeedback(input: $input) {
      id
    }
  }
`;

export const CREATE_DISCUSSION = gql`
  mutation CreateDiscussion($input: CreateDiscussionInput!) {
    createDiscussion(input: $input) {
      id
    }
  }
`;
